import {Directive, forwardRef, Input} from '@angular/core';
import {AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {ApiService} from '../_services/api.service';
import {ContactCollection} from '../../models/Collections/ContactCollection';
import {map, take} from 'rxjs/operators';

@Directive({
  selector: '[validateUniqueUsername][formControlName], [validateUniqueUsername][formControl], [validateUniqueUsername][ngModel]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => UniqueUsernameValidatorDirective), multi: true
    }
  ]
})
export class UniqueUsernameValidatorDirective implements Validator {

  @Input('validateUniqueUsername') contactId: number | string;

  constructor(private apiSvc: ApiService) {

  }

  validate(c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {

    const v = c.value;

    // we need to check if there's a contactId given to us, if it's given then we need to exclude that guy from the search

    // we don't want to contact the server with empty user names
    if (!c.value) {
      return of(null).pipe(take(1));
    }

    let params: any = {
      jsonQuery: {userName: v}
    };

    if (this.contactId > 0) {
      params.jsonQuery = {
        ...params.jsonQuery,
        id: {'!$eq': this.contactId}
      };
    }

    return this.apiSvc.getContacts(params).pipe(
      map((contactCollection: ContactCollection) => {
        if (contactCollection.data.length > 0) {
          return {nonUniqueUsername: true}
        }
        return null;
      })
    )
  }


}
